import { UtilService } from "src/app/service/util.service";
import { PagerService } from "src/app/service/pager.service";
import { MatTableDataSource, MatPaginator, MatSort } from "@angular/material";
import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";

@Component({
  selector: "app-search-admission-list",
  templateUrl: "./search-admission-list.component.html",
  styleUrls: ["./search-admission-list.component.css"],
})
export class SearchAdmissionListComponent implements OnInit {
  showLoadingIndicator: boolean;
  admissionList: any;

  dataSource: MatTableDataSource<any>;

  displayedColumns: string[] = [
    "StudentNumber",
    "ApplicatantFullName",
    "ProgrammeFullName",
    "Campus",
    "AdmittedBatch",
    "Hall",
    "Action",
  ];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  academicYear: string;
  // batchName: string;
  ShowAdmissionPrintOut: boolean;

  constructor(
    private utilService: UtilService,
    public pagerService: PagerService
  ) {}
  searchTerm = "";
  ngOnInit() {
    this.showLoadingIndicator = true;

    this.utilService.getSystemConfig().subscribe(
      (val) => {
        this.academicYear =
          val.ShowAdmittedBatchYearGroup +
          "/" +
          val.ShowAdmittedBatchYearGroup +
          1;
        // if (val.ShowAdmittedBactch === 1) {
        //   this.batchName = "FIRST BATCH RELEASED";
        // } else {
        //   this.batchName = "SECOND BATCH RELEASED";
        // }
        //  console.log(val);
        this.ShowAdmissionPrintOut = val.ShowAdmissionPrintOut;

        this.utilService.getAdmissionList().subscribe(
          (data) => {
            this.dataSource = new MatTableDataSource(
              data.sort(this.dynamicSort("StudentNumber"))
            );
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.showLoadingIndicator = false;
            // console.log(data);
          },
          (error) => {
            this.showLoadingIndicator = false;

            console.log(error);
          }
        );
      },
      (error) => {
        this.showLoadingIndicator = false;

        console.log(error);
      }
    );
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getBatchName(value) {
    if (value === 1) return "1st";
    if (value === 2) return "2nd";
    if (value === 3) return "3rd";
    else return value + "th";
  }

  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
}
